// extracted by mini-css-extract-plugin
export default {"clear_loading":"loader_clear_loading__XZcxC","loading_effect_4":"loader_loading_effect_4__yylJv","effectAnim":"loader_effectAnim__gvGNS"};